import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Page from "../../components/table/paging";
import { AdminPubPushLogResponse } from "../../api/admin/pub-grade";
import AdminAPI from "../../api/admin";
import PubGradeTable from "../../components/table/PubGradeTable";

const PushCountLog = () => {
  const [dataList, setDataList] = useState<AdminPubPushLogResponse[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const headers = [
    { text: "신청 날짜", align: "center", sortable: false, value: "createdAt" },
    { text: "매장", align: "center", sortable: false, value: "pubName" },
    {
      text: "조정 값",
      align: "center",
      sortable: false,
      value: "count",
    },
    {
      text: "처리 인원",
      align: "center",
      sortable: false,
      value: "username",
    },
  ];
  function formatDate(dateString: string) {
    if (!dateString) {
      return "Invalid Date";
    }

    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  const getRequest = async () => {
    const res = await AdminAPI.getPushLog();
    if (res) {
      const updatedData = res.map((item: AdminPubPushLogResponse) => ({
        ...item,
        createdAt: formatDate(item.createdAt),
      }));

      const totalPages = Math.ceil(updatedData.length / 10);
      setTotalPages(totalPages);
      setDataList(updatedData);
    }
  };

  useEffect(() => {
    getRequest();
  }, []);

  return (
    <>
      <DivStyle
        style={{ overflow: "auto" }}
        backgroundColor="#121212"
        height="100vh"
        display="flex"
        flex_direction="column"
        align_items="center"
        marginTop="65px"
      >
        <h2 style={{ color: "white", width: "95%", marginTop: "40px" }}>
          남은 푸시값 컨트롤 로그
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <PubGradeTable
            headers={headers}
            currentPage={currentPage}
            dataList={dataList}
            getDatas={getRequest}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={dataList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
    </>
  );
};

export default PushCountLog;
